import React from 'react';

/**
 * A small spinner for work with no shape yet and no known length: a button's
 * own action, a lookup, a popover filling in (docs/platform-standards.md §14).
 * It sits beside the thing it belongs to. It is never a full-page spinner;
 * for a region whose shape is known use a Skeleton, and for a measurable
 * upload or import use a progress bar.
 *
 *   <Spinner />
 *   <Spinner size='sm' label='Saving' showLabel />
 *
 * The ring is decoration (`aria-hidden`). `label` is the text: hidden from
 * sight by default so a screen reader still gets it, shown with `showLabel`,
 * and always shown, in place of the ring, under `prefers-reduced-motion`.
 * Pass `label={null}` when the control around it already says what is
 * happening (a button with its own present-tense label).
 *
 * The spinner is neutral ink, never `--action`.
 */
export default function Spinner({ size = 'md', label = 'Loading', showLabel = false, className = '', ...rest }) {
	return (
		<span
			className={`spinner spinner--${size === 'sm' ? 'sm' : 'md'}${showLabel ? ' spinner--labelled' : ''}${className ? ` ${className}` : ''}`}
			{...rest}
		>
			<span className='spinner__ring' aria-hidden='true' />
			{label ? <span className='spinner__label'>{label}</span> : null}
		</span>
	);
}
